const Footer = () => {
    return ( 
        <footer className="flex flex-col justify-center items-center lg:mt-10">
            <p className="text-center">
                Challenge by <a href="https://www.frontendmentor.io?ref=challenge" target="_blank" rel="noreferrer">Frontend Mentor</a>. 
               <br/> Coded by Alice.
            </p>
        </footer>
     );
}
 
export default Footer;